module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,Chemorozruch_DAkkS-IMS18-0031.7744e1a5.jpeg";